import { c as _c } from "react/compiler-runtime";
import { RuntimeSearchParamsContext } from '@spa/lib/react/context/RuntimeSearchParamsContext';
import { SearchParams } from '@spa/lib/pages/SearchParams';
import { useContext } from 'react';
const toURLSearchParams = (searchParams: SearchParams | null | undefined): URLSearchParams => {
  const entries: Array<[string, string]> = [];
  if (searchParams !== null && searchParams !== undefined) {
    for (const [key, value] of Object.entries(searchParams)) {
      if (Array.isArray(value)) {
        for (const v of value) {
          entries.push([key, v]);
        }
      } else if (value !== undefined) {
        entries.push([key, value]);
      }
    }
  }
  return new URLSearchParams(entries);
};
const useRuntimeSearchParams = () => {
  const $ = _c(2);
  const t0 = useContext(RuntimeSearchParamsContext);
  let t1;
  if ($[0] !== t0) {
    t1 = toURLSearchParams(t0);
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default useRuntimeSearchParams;